import React from "react";
import { StytchB2B } from "@stytch/react/b2b";
import { AuthFlowType, B2BProducts, B2BOAuthProviders } from "@stytch/vanilla-js";

const Login: React.FC = () => {
  // Custom styles for the Stytch login component
  const stytchStyles = {
    container: {
      backgroundColor: "#eef2f8ff", // slate-800
      borderColor: "#4a5568",     // slate-700
      borderRadius: "8px",
      color: "#ffffff",
      textColor: "#ffffff",
    },
    buttons: {
      primary: {
        backgroundColor: "#4299e1", // blue-500
        borderColor: "#4299e1",
        borderRadius: "4px",
      },
    },
    inputs: {
      backgroundColor: "#aaaeb4ff", // gray-900
      borderColor: "#4a5568",     // slate-700
      textColor: "#ffffff",
    },
    header: {
      color: "#ffffff",
    },
    message: {
      color: "#a0aec0", // gray-400
    },
  };

  const redirectUrl = `${window.location.origin}/authenticate`;

  const config = {
    products: [B2BProducts.emailMagicLinks, B2BProducts.oauth, B2BProducts.passwords],
    authFlowType: AuthFlowType.Discovery,
    // Removes the "create an organization" affordance from the discovery flow.
    // Not the security boundary — the Stytch Dashboard toggle and the
    // server-side platform-org check are — but it stops the flow being offered.
    disableCreateOrganization: true,
    emailMagicLinksOptions: {
      discoveryRedirectURL: redirectUrl,
    },
    oauthOptions: {
      providers: [{ type: B2BOAuthProviders.Google }],
      discoveryRedirectURL: redirectUrl,
    },
    passwordOptions: {
      loginRedirectURL: redirectUrl,
      resetPasswordRedirectURL: redirectUrl,
    },
    sessionOptions: {
      sessionDurationMinutes: 34560,
    },
  };

  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-900">
      <div className="w-full max-w-md p-6 bg-slate-800 rounded-lg shadow-xl">
        <h2 className="text-2xl font-bold mb-6 text-center text-white">Login to Pinstripe</h2>
        <StytchB2B config={config} styles={stytchStyles} />
      </div>
    </div>
  );
};

export default Login;
